import * as R from 'ramda'

export const creativeIdsSelector = partner => state => R.path([
  'partner', partner, 'creatives', 'ids'], state)
